export const i18n = {
    "en": {
        ADMINISTRATOR: "Administrator",
        TITLE: "Evaluations - AOQAN",
        TUMOUR_EVALUATIONS: "Head & neck (tumour) evaluations",
        TUMOUR_EVALUATIONS_TITLE: "Head & Neck Evaluations - AOQAN",
        RHINO_EVALUATIONS: "Rhinology evaluations",
        CI_EVALUATIONS: "Coclear implants evaluations",
        RHINO_EVALUATIONS_TITLE: "Rhinology Evaluations - AOQAN",
        CI_EVALUATIONS_TITLE: "Coclear implants Evaluations - AOQAN",
        DGHNO_CI_EVALUATIONS_TITLE: "Coclear implants Evaluations - CI-Register",
        ABSOLUTE_HINT: "Bars represent absolute percentages",
        ABSOLUTE_PERCENT: "Absolute [%]",
        ADD_AND_BLOCK: "Add new filter item (AND)",
        ADD_FILTERS: "Add filters...",
        ADD_OR_BLOCK: "Add filter block (OR)",
        AGE: "Age in years",
        AGE_INFO: "The age at the start of each case. If a patient has multiple cases it is calculated per case.",
        AND: "AND",
        BACK: "Back",
        BACK_TO_DASHBOARD: "Back to dashboard",
        CALCULATIONS_ARE_BEING_PROCESSED:
            "The calculations for the evaluations are currently being processed. Please come back a little later.",
        CASE_QUERY_TITLE: "Case properties",
        CASES_MULTIPLE_SURGEONS_INVOLVED: "Cases: multiple surgeons involved",
        CASES_WITH_RELAPSE: "Cases with relapse",
        CASES_WITH_SURGERY: "Cases with surgery",
        CENSORED: "Censored",
        CENSORING: "Censoring",
        CENSORING_INFO:
            "The occurrence of one of the following incidents leads to censorship: 1. Death (any cause), 2. the data collection period is shorter than the study length (minus the follow-up interval of 6 months)",
        CHECKBOX_AFTER_DATE_LABEL: "after",
        CHECKBOX_BEFORE_DATE_LABEL: "before",
        CHECKBOX_GREATER_THAN_LABEL: "Greater than",
        CHECKBOX_LESS_THAN_LABEL: "Less than",
        CHOOSE_FIELD_VALUE: "Choose field value",
        CHOOSE_OPERATOR: "Choose operator",
        CHOOSE_RECORD_FIELD: "Choose record field",
        CHOOSE_RECORD_TYPE: "Choose record type",
        CLINICAL_HISTOLOGY: "Clinical histology",
        CLINICAL_TNMS: "Clinical TNMs",
        COLLAPSE_ALL: "Collapse all",
        COMORBIDITIES: "Comorbidities",
        COMORBIDITIES_INFO:
            "A patient can have none or multiple comorbidities assigned. Therefore, the sum is most likely not equal to the number of patients.",
        COMPARE_WITH_NATIONAL_DATA: "Compare with national data",
        SELECT_ALL: "Select all...",
        COMPLICATIONS_BY_GRADE: "Complications by grade",
        COMPLICATIONS_OCCURRED: "Complications occurred",
        COUNT: "Count",
        COUNT_OF_SURGERIES: "Count of surgeries",
        COUNT_SYMBOL: "n",
        COUNT_SYMBOL_TITLE: "Number of data items",
        D: "d",
        DASHBOARD: "Dashboard",
        DATA_CONTEXT: "Data context",
        DATA_CONTEXT_INFO: "Open the AOQAN manual on the subject of the data context.",
        DATASET: "Dataset",
        DEACTIVATED_PATIENTS: "Deactivated patients",
        DEATH_BY_DISEASE: "Death by disease",
        DECEASED: "Deceased",
        DEMOGRAPHICS: "Demographics",
        EDIT: "Edit...",
        ERROR_WHILE_READING_DATA_OCCURRED: "The evaluation database is currently being updated. Please try again later.",
        EVALUATIONS: "Evaluations",
        EVENT: "Event",
        EVENT_INFO: "Death by disease",
        EXPAND_ALL: "Expand all",
        EXPORT_DATA_TO_CSV_DESCRIPTION: "The data of the current context are exported in CSV format.",
        EXPORT_DATA_TO_CSV_TITLE: "Export data to CSV",
        EXPORT_KM_DATA_TO_EXCEL: "Kaplan-Meier in Excel",
        EXPORT_KM_DATA_TO_EXCEL_DESCRIPTION:
            "Compare several Kaplan-Meier estimators in one diagram. Click on this button and follow the instructions in the file. See the AOQAN manual for more information.",
        EXPORT_RAW_DATA_TO_EXCEL: "Export raw data to Excel",
        EXPORT_RAW_DATA_TO_EXCEL_DESCRIPTION:
            "Click here to receive an email with a link to download the raw data as an Excel file. The basic set of data is determined by the selected context and possible query filter.",
        FILTERS_SELECTED: "filter constraint(s) selected.",
        FIRST_PATIENT_CONTACT: "First patient contact",
        FLAT_LIST: "Flat list",
        FULL_LIST: "Full list...",
        FURTHER_OPTIONS: "Further options",
        GENDER_FEMALE: "Gender female",
        GENDER_MALE: "Gender male",
        GENDER_NONBINARY: "Gender non binary",
        GENDER_UNKNOWN: "Gender unknown",
        FULL_LIST_HINT:
            "Darker colors represent items with child items. Lighter color represent leaf items (without children).",
        INFORMATION: "Information",
        INPUT_RADIO_FALSE: "No",
        INPUT_RADIO_FEMALE: "Female",
        INPUT_RADIO_MALE: "Male",
        INPUT_RADIO_NONBINARY: "Non binary",
        INPUT_RADIO_UNKNOWN: "Unknown",
        INPUT_RADIO_TRUE: "Yes",
        KAPLAN_MEIER_SURVIVAL_ANALYSIS: "Kaplan-Meier survival",
        KAPLAN_MEIER_SURVIVAL_ESTIMATOR: "Kaplan-Meier survival estimator",
        KM_EXCEL_DOWNLOAD_BUTTON: "Download KM for Excel",
        KM_StepLine_Censored_Text: "Censored",
        KM_StepLine_Confidence_Interval_Text: "95% confindece interval",
        KM_StepLine_Estimator_Text: "Kaplan-Meier estimator",
        LATEST_DATA_IMPORT: "Latest data import:",
        MARKED_AS_DELETED: "Marked as deleted",
        MAX: "Max",
        MAX_TITLE: "Maximum",
        MEAN: "Mean",
        MEAN_TITLE: "Arithmetic mean of the data",
        MED: "Med",
        MED_TITLE: "Median of the data",
        MEDIAN: "Median",
        MIN: "Min",
        MIN_TITLE: "Minimum",
        MRS: "Medical records",
        NAME: "Name",
        NO: "No",
        NO_DATA: "There are no evaluation data for the selected context.",
        NO_DATA_FOR_BAR_CHARTS: "<No data>",
        NUMBER_OF_CASES: "Number of cases",
        OR: "OR",
        PATHOLOGIC_TNMS: "Pathologic TNMs",
        PATHOLOGICAL_HISTOLOGY: "Pathological histology",
        PATIENT_DATA: "Patient data",
        PATIENT_QUERY_TITLE: "Patient attributes",
        PATIENTS: "Patients",
        PATIENTS_WITH_MULTIPLE_CASES: "Patients with multiple cases",
        PATIENTS_WITH_SINGLE_CASE: "Patients with single case",
        PROBABILITY_S_T: "Probability S(t)",
        PROCEDURES_MBS_CODES: "Procedures (MBS codes)",
        QUERY_FILTERS: "Query filters",
        QUERY_FILTERS_INFO: "Open the AOQAN manual on the subject of query filters.",
        RECEPTION_OF_REFERRAL: "Reception of referral",
        RELATIVE_HINT: "Bars represent relative percentages",
        RELATIVE_PERCENT: "Relative [%]",
        REMOVE_ALL_FILTERS: "Remove all filters",
        REMOVE_FILTER_LINE: "Remove this filter line",
        REMOVE_QUERY_BLOCK: "Remove this filter block",
        S_T: "S(t)",
        SCORE: "Score",
        STD: "SD",
        STD_DEV: "SD",
        STD_DEV_TITLE: "Standard deviation",
        STUDY_LENGTH_5_YEARS: "Study length: 5 years",
        SUBJ_AT_RISK: "At risk",
        SURGERY_NOT_IN_PLANNED_TREATMENT: "Surgery not in 'Planned treatment'",
        SURGERY_STATISTICS: "Surgery statistics",
        TIME_D: "Time [d]",
        TIME_MO: "Time [mo]",
        TIME_PROGRESS: "Time progress",
        TIME_PROGRESS_INFO:
            "The 'Time progress' card displays statistics about the number of days between certain dates. n can vary because some cases do not have a surgery record.",
        TREATMENT_FIRST_SURGERY: "Treatment: first surgery",
        TREE_VIEW: "Tree view",
        TUMOUR_CASE_STATISTICS: "Tumour case statistics",
        RHINO_CASE_STATISTICS: "Case statistics",
        TUMOUR_STATISTICS: "Tumour statistics",
        TUMOURS_BY_LOCALISATION: "Tumours by localisation",
        Y: "y",
        SELECT_CONTEXT: "Select context",
        RHINOLOGY_STATISTICS: "Rhinology statistics",
        CI_STATISTICS: "Coclear implants statistics",
        CASES: "Cases",
        SURGERY: "Surgery",
        MEDICAL_FOLLOW_UP: "Medical follow-up",
        QUESTIONNAIRES: "Questionnaires",
        RHINO_DIAGNOSES: "Diagnoses",
        PRE_OP: "Pre op",
        THREE_MONTHS_POST_OP: "3 mo post op",
        TWELVE_MONTHS_POST_OP: "12 mo post op",
        NOSE: "NOSE",
        SNOT_22: "SNOT-22",
        VAS: "VAS",
        HOSPITAL_STAY: "Hospital stay",
        HOSPITAL_STAY_HINT: "How many nights did you stay in hospital?",
        BACK_TO_NORMAL_ACTIVITY: "Back to normal activity",
        BACK_TO_NORMAL_ACTIVITY_HINT: "When did you get back to normal activity (work/school)?",
        UNPLANNED_VISIT: "Unplanned visit",
        UNPLANNED_VISIT_HINT: "Did you require an unplanned visit your otolaryngologist after the surgery?",
        REASONS: "Reasons",
        PROBLEMS_AFTER_SURGERY: "Problems after surgery",
        PROBLEMS_AFTER_SURGERY_HINT: "In the first 30 days after surgery, did you experience any of the following problems",
        PROBLEMS: "Problems",
        IMAGE_GUIDED_SURGERY: "Image guided surgery (IGS)",
        NASAL_PACKING: "Nasal packing",
        INTRA_OP_COMPLICATIONS: "Intra-op complications",
        SURGERIES: "Surgeries",
        SURGERY_COUNT: "Surgery count",
        N: "n",
        LABORATORY_RESULTS: "Laboratory results",
        SERUM_IGE: "Serum IgE (UI/ml)",
        LEVEL_OF_EOSINOPHILS: "Level of eosinophils (cells per dl)",
        SYMPTOMS_LUND_MACKAY: "Symptoms: Lund-Mackay",
        SYMPTOMS_LUND_KENNEDY: "Symptoms: Lund-Kennedy",
        CI_MRI_DONE: "CI / MRI done",
        SECRETION: "Secretion",
        EDEMA: "Edema",
        POLYP_SIZE: "Polyp size",
        MACKAY_SCORE: "Lund-Mackay total score",
        KENNEDY_SCORE: "Lund-Kennedy total score",
        SMOKING: "Smoking",
        NOSE_AND_SINUS_FUNCTION: "Nose and sinus function",
        ANCHOR_SCORE: "Anchor score",
        LUNG_LOWER_AIRWAY_FUNCTION: "Lung/lower airway function",
        LUNG_LOWER_AIRWAY_FUNCTION_HINT: "Do you have lung/lower airway problems?",
        LUNG_LOWER_AIRWAY_FUNCTION_ANCHOR_SCORE: "Lung/lower airway anchor score",
        SNOT_MOST_IMPORTANT_ITEMS: "SNOT-22: Most important items",
        VAS_AND_STATUS: "VAS & status",
        OTHER: "Other...",
        NEVER_SMOKED: "Never smoked",
        QUIT_DURING_LAST_TWELVE_MOTNHS: "Quit during last 12 months",
        QUIT_MORE_THAN_TWELVE_MOTNHS: "Quit more than 12 months ago",
        SMOKES_CURRENTLY: "Smokes currently",
        SNOT_22_AND_NOSE: "SNOT-22 & NOSE",
        GENERAL: "General",
        CI_STATUS: "CI status",
        PERFORMANCE_TESTS: "Performance tests",
        FUNDING: "Funding",
        IMAGING: "Imaging",
        ABNORMAL_FINDINGS: "Abnormal findings",
        COCHLEAR_MALFORMATION_DETAIL: "Cochlear malformation, detail",
        COCHLEAR_NERVE_DISORDER_DETAIL: "Cochlear nerve disorder, detail",
        AETIOLOGY: "Aetiology",
        COMMUNICATION_MODE_PRE_OPERATIVE: "Communication mode (pre-operative)",
        GENETIC_HL_DETAIL: "Genetic HL, detail",
        IF_ACQUIRED: "If acquired",
        INFECTIVE_HL_DETAIL: "Infective HL, detail",
        NEONATAL_PREMATURITY_HL_DETAIL: "Neonatal/prematurity HL, detail",
        ONSET_OF_HEARING_LOSS: "Onset of hearing loss",
        SYNDROMAL_HL_DETAIL: "Syndromal HL, detail",
        DESCRIPTION_OF_THE_HEARING_LOSS: "Description of the hearing loss",
        EXPLANTATIONS: "Explantations",
        COUNT_OF_EXPLANTS: "Count of explants (Explantation only and Reimplantations)",
        EXPLANTS_BY_MANUFACTURER: "Explants by manufacturer",
        EXPLANTATION_REASONS: "Explantation reasons",
        IMPLANTS_BY_MANUFACTURER: "Implants by manufacturer",
        IMPLANT: "Implant",
        ELECTRODE: "Electrode",
        PIN: "Pin",
        INTRA_OP_DATA: "Intra-OP data",
        NRT_RESPONSE: "NRT Response",
        COMPLICATIONS: "Complications",
        ELECTRODE_INSERTION: "Electrode insertion",
        NUMBER_OF_NOT_INSERTED_ELECTRODES: "Number of NOT inserted electrodes",
        ELECTRODE_RELATED_ISSUES: "Electrode related issues",
        NUMBER_OF_AFFECTED_ELECTRODES: "Number of affected electrodes",
        REVISIONS: "Revisions",
        REVISIONS_COUNT: "Revision count",
        REASON_FOR_THE_REVISION: "Reason for the revision",
        DETAILS: "Details",
        SOUND_PROCESSOR_MANUFACTURER: "Sound processor manufacturer",
        IMPLANT_STATUS: "Implant status",
        CHARACTERISTIC_DECREMENTS_DEVICE_ISSUES: "Characteristic decrements (device issues)",
        ELECTRODE_RELATED_ISSUES: "Electrode-related issues",
        MEDICAL_STATUS: "Medical status",
        MEDICAL_PROBLEM_D: "Medical problem (D)",
        NUMBER_OF_NOT_WORKING_ELECTRODES: "Number of electrodes not working",
        PREOP_ON_SURGERY_SIDE: "Preop, on surgery side",
        TWELVE_MO_POSTOP_ON_SURGERY_SIDE: "12 mo postop, on surgery side",
        PURE_TONE_AUDIOMETRY_UNAIDED: "Pure tone audiometry, unaided",
        PTA_500_4K_PREOP_DB: "PTA 500-4k, preop [dB]",
        PURE_TONE_AUDIOMETRY_WITH_CI: "Pure tone audiometry, with CI",
        PTA_500_4K_FF_CI_DB: "PTA 500-4k, FF with CI [dB]",
        SPEECH_PERCEPTION_WITH_HA: "Speech perception, with HA",
        SPEECH_PERCEPTION_WITH_CI: "Speech perception, with CI",
        BKB: "BKB [%]",
        CUNY: "CUNY [%]",
        CNC_WORDS: "CNC words [%]",
        CNC_PHONEMES: "CNC phonemes [%]",
        IN_QUIET: "In quiet (signal 65 dB SPL)",
        IN_NOISE: "In noise",
        BKB_IN_NOISE: "BKB [%] (10 dB SNR)",
        CUNY_IN_NOISE: "CUNY (10 dB SNR)",
        SNR_IN_NOISE: "SNR/AuSTIN [dB]",
        SIGNAL_65_DB_SPL: "Signal 65 dB SPL",
        KIDS_SPEECH_PERCEPTION_WITH_HA: "Kids speech perception, with HA",
        KIDS_SPEECH_PERCEPTION_WITH_CI: "Kids speech perception, with CI",
        MANCHESTER_WORDS: "Manchester words [%]",
        MANCHESTER_VOWELS: "Manchester vowels [%]",
        MANCHESTER_CONSONATS: "Manchester consonats [%]",
        MANCHESTER_PHONEMES: "Manchester phonemes [%]",
        DE_VAULT_COMMON_PHRASES: "De Vault common phrases [%]",
        SPEECH_SPATIAL_QUALIATIES_WITH_HA: "Speech Spatial Qualities (SSQ), with HA",
        SPEECH_SPATIAL_QUALIATIES_WITH_CI: "Speech Spatial Qualities (SSQ), with CI",
        SPEECH_HEARING: "Speech hearing",
        SPACIAL_HEARING: "Spacial hearing",
        QUALITY_OF_HEARING: "Quality of hearing",
        OVERALL_SCORE: "Overall score",
        IT_MAIS_WITH_CI: "IT-MAIS, with CI",
        IT_MAIS_SCORE: "IT-MAIS score",
        ERROR_500_TEXT:
            'We are sorry, an error occurred. Please try again later. If the error persists, please <a href="https://www.aoqan.org/contact/" target="_blank">contact the supprt team</a>.',
        PATIENT_AGE_16_YEARS: "Patient age: 16 yrs",
        TOTAL_NUMBER_OF_PATIENTS: "Total number of patients",
        UNDER_16_YEARS: "Under 16 years",
        PREMATURITY: "Prematurity",
        INTERVENTIONS: "Interventions",
        TONSILLECTOMY: "Tonsillectomy",
        ADENOIDECTOMY: "Adenoidectomy",
        GROMMET_SURGERY: "Grommet Surgery",
        INTERVENTIONS_HINT: "* Related to the total number of cases",
        GROMMETS: "Grommets",
        TONSILS_AND_ADENOIDS: "Tonsils/Adenoids",
        PRE_OP_ASSESSMENT: "Pre-op assessment",
        HEARING_ASSESSMENT: "Hearing assessment",
        MAIN_INDICATION: "Main indication",
        SLEEP: "Sleep",
        INDICATION: "Indication",
        OTITIS_MEDIA_HISTORY_ASSESSMENT: "Otitis media history assessment",
        GROMMET_SIDES: "Grommet sides",
        FIRST_GROMMET_INSERTION: "First grommet insertion",
        TYPE_OF_GROMMET: "Type of Grommet",
        WITH_ADENOIDECTOMY: "With adenoidectomy",
        ADENOIDECTOMY_DONE_BEFORE_HINT: "Has an adenoidectomy been done before?",
        ADENOIDECTOMY_DONE_THIS_TIME_HINT: "Has an adenoidectomy done this time?",
        EARDROPS: "Eardrops",
        EARDROPS_INTRA_OPERATIVELY_HINT: "Intra-operatively",
        EARDROPS_POST_SURGERY_HINT: "Prescription for use post surgery",
        POST_OP_REVIEW: "Post-op review",
        POST_OP_APPOINTMENT: "Post-op appointment",
        IN_SITE_PATENT: "Grommet in-site/patent",
        RIGHT_EAR: "RIGHT EAR",
        LEFT_EAR: "LEFT EAR",
        POST_OP_REVIEW_AFTER_GROMMET_INDICATION_HINT: "Hearing assessment after grommet indication?",
        AUDIOGRAMS: "Audiograms",
        AUDIOGRAMS_HINT: "If an audiogram has been performed pre- and post-op, has there been a 10 dB or better improvement at 1000 Hz?",
        OTORRHEA_CARD_TITLE: "Was otorrhea present and/or reported in one or both ears?",
        TELEHEALTH: "Telehealth",
        TIME_AFTER_SURGERY: "Time after surgery",
        OM_6_QUESTIONNAIRE: "OM-6 questionnaire",
        TOTAL_SCORE_OM_6: "Total score (OM-6)",
        OTITIS_MEDIA_6_OM_6: "Otitis Media-6 (OM-6)",
        ONE_MONTH_POST_OP: "1 mo post op",
        SIX_MONTHS_POST_OP: "6 mo post op",
        OM_SIX_SCORE: "OM-6 score",
        T_14_SCORE: "T-14 score",
        TONSILS_ADENOIDS_GROMMETS_STATISTICS: "Tonsils/Adenoids/Grommets statistics",
        TAG_EVALUATIONS: "TAG evaluations",
        TAG_EVALUATIONS_TITLE: "TAG Evaluations - AOQAN",
        IN_SITU_PATENT: "Grommet in-situ/patent",
        HOW_TO_LOAD_DATA_PLEASE_SET_YOUR: "Please set your",
        HOW_TO_LOAD_DATA_FILTER_CRITERIA: "Filter criteria",
        HOW_TO_LOAD_DATA_OR: "or",
        HOW_TO_LOAD_DATA_GET_ALL_DATA: "Get all data",
        RECORDS: "Records",
        OPEN: "Open",
        TYPE_OF_STAY: "Type of stay",
        TYPE_OF_SURGERY: "Type of surgery",
        PROCEDURE: "Procedure",
        SURGICAL_TECHNIQUE: "Surgical technique",
        HAEMOSTASIS_TECHNIQUE: "Technique for haemostasis",
        COLD_TECHNIQUE: "Cold technique",
        HOT_TECHNIQUE: "Hot technique",
        SURGERY_OUTCOME: "Outcome of surgery",
        PAINKILLER_PRESCRIBED: "Painkiller prescribed or recommended",
        ANTIBIOTICS_PRESCRIBED: "Antibiotics prescribed at discharge",
        FOLLOW_UP_VISIT: "Follow-up visit was planned",
        EAT_REGULAR_FOOD: "Eat regular food (number of days after surgery)",
        PAIN_FREE: "Get pain free (number of days after surgery)",
        BLOOD_TRANSFUSION: "Blood transfusion required",
        BLEEDING: "Bleeding",
        BLEEDING_EVIDENCE: "Evidence of bleeding that prompted contact with a health professional after discharge",
        BLEEDING_HOSPITAL_FIRST: "Patient admitted or presented to hospital due to bleeding from the throat",
        BLEEDING_HOSPITAL_SECOND: "Secondary operation",
        SLEEP: "Sleep",
        SLEEP_STUDY_PERFORMED: "Sleep study performed",
        APNEA_HYPOPNEA_INDEX: "Apnea-Hypopnea Index (AHI)",
        PATIENT_OVER_16: "Patient over 16 years old",
        PATIENT_UNDER_16: "Patient under 16 years old",
        LOCAL_ANAESTETIC: "Local anaestetic intra operative",
        T_14_QUESTIONNAIRE: "T-14 questionnaire",
        TOTAL_SCORE_T_14: "Total score (T-14)",
        OBSTRUCTIVE_SCORE_T_14: "Obstructive score (T-14)",
        INFECTIVE_SCORE_T_14: "Infective score (T-14)",
        PAEDIATRIC_THROAT_DISORDER_OUTCOME_TEST_T_14: "Paediatric Throat disorders Outcome Test (T-14)",
        DOWNLOAD_HEADER: "File download",
        DOWNLOAD_DETAILS: "Your download will start in a few seconds automatically. If it does not start automatically, you can click on this link to",
        DOWNLOAD_LINK: "start the download again manually.",
        DOWNLOAD_NOTES: "Please note that the download may take a moment to start, depending on your network connection and browser settings. Thank you for your patience. After the download you can close this browser tab."
    },
    "de": {
        ADMINISTRATOR: "Administrator",
        TITLE: "Auswertungen",
        TUMOUR_EVALUATIONS: "Head & neck (tumour) evaluations",
        TUMOUR_EVALUATIONS_TITLE: "Head & Neck Evaluations - AOQAN",
        RHINO_EVALUATIONS: "Rhinology evaluations",
        CI_EVALUATIONS: "CI-Auswertungen",
        RHINO_EVALUATIONS_TITLE: "Rhinology Evaluations - AOQAN",
        CI_EVALUATIONS_TITLE: "CI-Auswertungen",
        DGHNO_CI_EVALUATIONS_TITLE: "Auswertung - CI-Register",
        ABSOLUTE_HINT: "Die Balken stellen absolute Prozentsätze dar.",
        ABSOLUTE_PERCENT: "Absolut [%]",
        ADD_AND_BLOCK: "Neuer Filter (UND)",
        ADD_FILTERS: "Neuer Filter ...",
        ADD_OR_BLOCK: "Neuer Filter (ODER)",
        AGE: "Alter in Jahren",
        AGE_INFO: "Das Alter zu Beginn eines jeden Falles. Wenn ein Patient mehrere Fälle hat, wird es pro Fall berechnet.",
        AND: "UND",
        BACK: "Zurück",
        BACK_TO_DASHBOARD: "Zurück zum Dashboard",
        CALCULATIONS_ARE_BEING_PROCESSED:
            "Die Berechnungen für die Auswertungen werden derzeit bearbeitet. Bitte kommen Sie etwas später wieder.",
        CASE_QUERY_TITLE: "Eigenschaften eines Falls",
        CASES_MULTIPLE_SURGEONS_INVOLVED: "Fälle: mehrere Benutzer/Chirurgen beteiligt",
        CASES_WITH_RELAPSE: "Fälle mit Rezidiv",
        CASES_WITH_SURGERY: "Fälle mit Operation",
        CENSORED: "Zensiert",
        CENSORING: "Zensieren",
        CENSORING_INFO:
            "Das Auftreten eines der folgenden Vorfälle führt zur Zensur: 1. Tod (beliebige Ursache), 2. der Zeitraum der Datenerhebung ist kürzer als die Studiendauer (abzüglich des Follow-up-Intervalls von 6 Monaten)",
        CHECKBOX_AFTER_DATE_LABEL: "Nach",
        CHECKBOX_BEFORE_DATE_LABEL: "Vor",
        CHECKBOX_GREATER_THAN_LABEL: "Nach",
        CHECKBOX_LESS_THAN_LABEL: "Vor",
        CHOOSE_FIELD_VALUE: "Wert auswählen",
        CHOOSE_OPERATOR: "Operator auswählen",
        CHOOSE_RECORD_FIELD: "Feld auswählen",
        CHOOSE_RECORD_TYPE: "Typ auswählen",
        CLINICAL_HISTOLOGY: "Klinische Histologie",
        CLINICAL_TNMS: "Klinische TNM-Klassifikation",
        COLLAPSE_ALL: "Alle einklappen",
        COMORBIDITIES: "Begleiterkrankungen",
        COMORBIDITIES_INFO:
            "Einem Patienten können keine oder mehrere Begleiterkrankungen zugeordnet sein. Daher ist die Summe höchstwahrscheinlich nicht gleich der Anzahl der Patienten.",
        COMPARE_WITH_NATIONAL_DATA: "Vergleich mit nationalen Daten",
        SELECT_ALL: "Alle auswählen...",
        COMPLICATIONS_BY_GRADE: "Komplikationen nach Grad",
        COMPLICATIONS_OCCURRED: "Komplikationen aufgetreten",
        COUNT: "Zähler",
        COUNT_OF_SURGERIES: "Anzahl der Operationen",
        COUNT_SYMBOL: "n",
        COUNT_SYMBOL_TITLE: "Anzahl der Datenelemente",
        D: "d",
        DASHBOARD: "Dashboard",
        DATA_CONTEXT: "Datenkontext",
        DATA_CONTEXT_INFO: "Öffnen Sie das Handbuch zum Thema Datenkontext.",
        DATASET: "Datensatz",
        DEACTIVATED_PATIENTS: "Deaktivierte Patienten",
        DEATH_BY_DISEASE: "Tod in Verbindung mit der Behandlung",
        DECEASED: "Verstorben",
        DEMOGRAPHICS: "Demogrphie",
        EDIT: "Bearbeiten...",
        ERROR_WHILE_READING_DATA_OCCURRED: "Die Bewertungsdatenbank wird derzeit aktualisiert. Bitte versuchen Sie es später noch einmal.",
        EVALUATIONS: "Auswertungen",
        EVENT: "Ereignis",
        EVENT_INFO: "Tod in Verbindung mit der Behandlung",
        EXPAND_ALL: "Alle aufklappen",
        EXPORT_DATA_TO_CSV_DESCRIPTION: "Die Daten des aktuellen Kontexts werden im CSV-Format exportiert.",
        EXPORT_DATA_TO_CSV_TITLE: "Daten als CSV exportieren",
        EXPORT_KM_DATA_TO_EXCEL: "Kaplan-Meier in Excel",
        EXPORT_KM_DATA_TO_EXCEL_DESCRIPTION:
            "Vergleichen Sie mehrere Kaplan-Meier-Schätzer in einem Diagramm. Klicken Sie auf diese Schaltfläche und folgen Sie den Anweisungen in der Datei. Weitere Informationen finden Sie im AOQAN-Handbuch.",
        EXPORT_RAW_DATA_TO_EXCEL: "Rohdaten als Excel exportieren",
        EXPORT_RAW_DATA_TO_EXCEL_DESCRIPTION:
            "Klicken Sie hier, um die Rohdaten als Excel-Datei herunterzuladen. Der Datensatz wird durch den gewählten Kontext und mögliche Abfragefilter bestimmt.",
        FILTERS_SELECTED: "Filter ausgewählt.",
        FIRST_PATIENT_CONTACT: "Erster Patientenkontakt",
        FLAT_LIST: "Listenansicht",
        FULL_LIST: "Alle anzeigen ...",
        FURTHER_OPTIONS: "Weitere Optionen",
        GENDER_FEMALE: "Geschlecht Weiblich",
        GENDER_MALE: "Geschlecht Männlich",
        GENDER_NONBINARY: "Geschlecht Divers",
        GENDER_UNKNOWN: "Geschlecht Unbekannt",
        FULL_LIST_HINT:
            "Dunklere Farben stehen für Elemente mit untergeordneten Elementen. Hellere Farben stehen für Blattelemente (ohne Kinder).",
        INFORMATION: "Information",
        INPUT_RADIO_FALSE: "Nein",
        INPUT_RADIO_FEMALE: "Weiblich",
        INPUT_RADIO_MALE: "Männlich",
        INPUT_RADIO_NONBINARY: "Divers",
        INPUT_RADIO_UNKNOWN: "Unbekannt",
        INPUT_RADIO_TRUE: "Ja",
        KAPLAN_MEIER_SURVIVAL_ANALYSIS: "Kaplan-Meier Überlebensanalyse",
        KAPLAN_MEIER_SURVIVAL_ESTIMATOR: "Kaplan-Meier-Schätzer",
        KM_EXCEL_DOWNLOAD_BUTTON: "KM für Excel herunterladen",
        KM_StepLine_Censored_Text: "Zensiert",
        KM_StepLine_Confidence_Interval_Text: "95% Konfidenzintervall",
        KM_StepLine_Estimator_Text: "Kaplan-Meier-Schätzer",
        LATEST_DATA_IMPORT: "Letzter Datenimport:",
        MARKED_AS_DELETED: "Als gelöscht markiert",
        MAX: "Max",
        MAX_TITLE: "Maximum",
        MEAN: "Mean",
        MEAN_TITLE: "Arithmetisches Mittel der Daten",
        MED: "Med",
        MED_TITLE: "Median der Daten",
        MEDIAN: "Median",
        MIN: "Min",
        MIN_TITLE: "Minimum",
        MRS: "Einträge",
        NAME: "Name",
        NO: "Nein",
        NO_DATA: "Für den gewählten Kontext liegen keine Daten vor.",
        NO_DATA_FOR_BAR_CHARTS: "<Keine Daten>",
        NUMBER_OF_CASES: "Anzahl der Fälle",
        OR: "ODER",
        PATHOLOGIC_TNMS: "Pathologiesche TNM-Klassifikation",
        PATHOLOGICAL_HISTOLOGY: "Pathologische Histologie",
        PATIENT_DATA: "Patientendaten",
        PATIENT_QUERY_TITLE: "Eigenschaften von Patienten",
        PATIENTS: "Patienten",
        PATIENTS_WITH_MULTIPLE_CASES: "Patienten mit mehreren Fällen",
        PATIENTS_WITH_SINGLE_CASE: "Patienten mit genau einem Fall",
        PROBABILITY_S_T: "Wahrscheinlichkeit S(t)",
        PROCEDURES_MBS_CODES: "Behandlungskodierung (MBS codes)",
        QUERY_FILTERS: "Abfragefilter",
        QUERY_FILTERS_INFO: "Öffnen Sie das Handbuch zum Thema Abfragefilter.",
        RECEPTION_OF_REFERRAL: "Entgegennahme der Überweisung",
        RELATIVE_HINT: "Die Balken stellen relative Prozentsätze dar.",
        RELATIVE_PERCENT: "Relativ [%]",
        REMOVE_ALL_FILTERS: "Alle Filterkriterien löschen",
        REMOVE_FILTER_LINE: "Dieses Filterkriterium löschen",
        REMOVE_QUERY_BLOCK: "Diesen Filterblock löschen",
        S_T: "S(t)",
        SCORE: "Score",
        STD: "SD",
        STD_DEV: "SD",
        STD_DEV_TITLE: "Standardabweichung",
        STUDY_LENGTH_5_YEARS: "Studienlänge: 5 Jahre",
        SUBJ_AT_RISK: "Gefährdet",
        SURGERY_NOT_IN_PLANNED_TREATMENT: "Operation nicht in 'Geplante Behandlung'",
        SURGERY_STATISTICS: "Statistik der Operationen",
        TIME_D: "Zeit [d]",
        TIME_MO: "Zeit [mo]",
        TIME_PROGRESS: "Zeitverlauf",
        TIME_PROGRESS_INFO:
            "Die Karte 'Zeitlicher Verlauf' zeigt Statistiken über die Anzahl der Tage zwischen bestimmten Daten an. n kann variieren, da für einige Fälle kein OP-Datensatz vorhanden ist.",
        TREATMENT_FIRST_SURGERY: "Behandlung: erste Operation",
        TREE_VIEW: "Baumansicht",
        TUMOUR_CASE_STATISTICS: "Statistik Tumorfälle",
        RHINO_CASE_STATISTICS: "Fallstatistik",
        TUMOUR_STATISTICS: "Tumorstatistik",
        TUMOURS_BY_LOCALISATION: "Tumore nach Lokalisation",
        Y: "y",
        SELECT_CONTEXT: "Kontext auswählen ...",
        RHINOLOGY_STATISTICS: "Rhinology statistics",
        CI_STATISTICS: "Coclear implants statistics",
        CASES: "Fälle",
        SURGERY: "Operation",
        MEDICAL_FOLLOW_UP: "Medizinische Nachsorge",
        QUESTIONNAIRES: "Fragebögen",
        RHINO_DIAGNOSES: "Diagnosen",
        PRE_OP: "Prä-op",
        THREE_MONTHS_POST_OP: "3 mo post-op",
        TWELVE_MONTHS_POST_OP: "12 mo post-op",
        NOSE: "NOSE",
        SNOT_22: "SNOT-22",
        VAS: "VAS",
        HOSPITAL_STAY: "Krankenhausaufenthalt",
        HOSPITAL_STAY_HINT: "How many nights did you stay in hospital?",
        BACK_TO_NORMAL_ACTIVITY: "Back to normal activity",
        BACK_TO_NORMAL_ACTIVITY_HINT: "When did you get back to normal activity (work/school)?",
        UNPLANNED_VISIT: "Unplanned visit",
        UNPLANNED_VISIT_HINT: "Did you require an unplanned visit your otolaryngologist after the surgery?",
        REASONS: "Reasons",
        PROBLEMS_AFTER_SURGERY: "Problems after surgery",
        PROBLEMS_AFTER_SURGERY_HINT: "In the first 30 days after surgery, did you experience any of the following problems",
        PROBLEMS: "Problems",
        IMAGE_GUIDED_SURGERY: "Image guided surgery (IGS)",
        NASAL_PACKING: "Nasal packing",
        INTRA_OP_COMPLICATIONS: "Intra-op complications",
        SURGERIES: "Surgeries",
        SURGERY_COUNT: "Surgery count",
        N: "n",
        LABORATORY_RESULTS: "Laboratory results",
        SERUM_IGE: "Serum IgE (UI/ml)",
        LEVEL_OF_EOSINOPHILS: "Level of eosinophils (cells per dl)",
        SYMPTOMS_LUND_MACKAY: "Symptoms: Lund-Mackay",
        SYMPTOMS_LUND_KENNEDY: "Symptoms: Lund-Kennedy",
        CI_MRI_DONE: "CI / MRI done",
        SECRETION: "Secretion",
        EDEMA: "Edema",
        POLYP_SIZE: "Polyp size",
        MACKAY_SCORE: "Lund-Mackay total score",
        KENNEDY_SCORE: "Lund-Kennedy total score",
        SMOKING: "Smoking",
        NOSE_AND_SINUS_FUNCTION: "Nose and sinus function",
        ANCHOR_SCORE: "Anchor score",
        LUNG_LOWER_AIRWAY_FUNCTION: "Lung/lower airway function",
        LUNG_LOWER_AIRWAY_FUNCTION_HINT: "Do you have lung/lower airway problems?",
        LUNG_LOWER_AIRWAY_FUNCTION_ANCHOR_SCORE: "Lung/lower airway anchor score",
        SNOT_MOST_IMPORTANT_ITEMS: "SNOT-22: Most important items",
        VAS_AND_STATUS: "VAS & status",
        NEVER_SMOKED: "Never smoked",
        QUIT_DURING_LAST_TWELVE_MOTNHS: "Quit during last 12 months",
        QUIT_MORE_THAN_TWELVE_MOTNHS: "Quit more than 12 months ago",
        SMOKES_CURRENTLY: "Smokes currently",
        SNOT_22_AND_NOSE: "SNOT-22 & NOSE",
        GENERAL: "General",
        CI_STATUS: "CI status",
        PERFORMANCE_TESTS: "Performance tests",
        FUNDING: "Funding",
        IMAGING: "Imaging",
        ABNORMAL_FINDINGS: "Abnormal findings",
        COCHLEAR_MALFORMATION_DETAIL: "Cochlear malformation, detail",
        COCHLEAR_NERVE_DISORDER_DETAIL: "Cochlear nerve disorder, detail",
        AETIOLOGY: "Aetiology",
        COMMUNICATION_MODE_PRE_OPERATIVE: "Communication mode (pre-operative)",
        GENETIC_HL_DETAIL: "Genetic HL, detail",
        IF_ACQUIRED: "If acquired",
        INFECTIVE_HL_DETAIL: "Infective HL, detail",
        NEONATAL_PREMATURITY_HL_DETAIL: "Neonatal/prematurity HL, detail",
        ONSET_OF_HEARING_LOSS: "Onset of hearing loss",
        SYNDROMAL_HL_DETAIL: "Syndromal HL, detail",
        DESCRIPTION_OF_THE_HEARING_LOSS: "Description of the hearing loss",
        EXPLANTATIONS: "Explantations",
        COUNT_OF_EXPLANTS: "Count of explants (Explantation only and Reimplantations)",
        EXPLANTS_BY_MANUFACTURER: "Explants by manufacturer",
        EXPLANTATION_REASONS: "Explantation reasons",
        IMPLANTS_BY_MANUFACTURER: "Implants by manufacturer",
        IMPLANT: "Implant",
        ELECTRODE: "Electrode",
        PIN: "Pin",
        INTRA_OP_DATA: "Intra-OP data",
        NRT_RESPONSE: "NRT Response",
        COMPLICATIONS: "Complications",
        ELECTRODE_INSERTION: "Electrode insertion",
        NUMBER_OF_NOT_INSERTED_ELECTRODES: "Number of NOT inserted electrodes",
        ELECTRODE_RELATED_ISSUES: "Electrode related issues",
        NUMBER_OF_AFFECTED_ELECTRODES: "Number of affected electrodes",
        REVISIONS: "Revisions",
        REVISIONS_COUNT: "Revision count",
        REASON_FOR_THE_REVISION: "Reason for the revision",
        DETAILS: "Details",
        SOUND_PROCESSOR_MANUFACTURER: "Sound processor manufacturer",
        IMPLANT_STATUS: "Implant status",
        CHARACTERISTIC_DECREMENTS_DEVICE_ISSUES: "Characteristic decrements (device issues)",
        ELECTRODE_RELATED_ISSUES: "Electrode-related issues",
        MEDICAL_STATUS: "Medical status",
        MEDICAL_PROBLEM_D: "Medical problem (D)",
        NUMBER_OF_NOT_WORKING_ELECTRODES: "Number of electrodes not working",
        PREOP_ON_SURGERY_SIDE: "Preop, on surgery side",
        TWELVE_MO_POSTOP_ON_SURGERY_SIDE: "12 mo postop, on surgery side",
        PURE_TONE_AUDIOMETRY_UNAIDED: "Pure tone audiometry, unaided",
        PTA_500_4K_PREOP_DB: "PTA 500-4k, preop [dB]",
        PURE_TONE_AUDIOMETRY_WITH_CI: "Pure tone audiometry, with CI",
        PTA_500_4K_FF_CI_DB: "PTA 500-4k, FF with CI [dB]",
        SPEECH_PERCEPTION_WITH_HA: "Speech perception, with HA",
        SPEECH_PERCEPTION_WITH_CI: "Speech perception, with CI",
        BKB: "BKB [%]",
        CUNY: "CUNY [%]",
        CNC_WORDS: "CNC words [%]",
        CNC_PHONEMES: "CNC phonemes [%]",
        IN_QUIET: "In quiet (signal 65 dB SPL)",
        IN_NOISE: "In noise",
        BKB_IN_NOISE: "BKB [%] (10 dB SNR)",
        CUNY_IN_NOISE: "CUNY (10 dB SNR)",
        SNR_IN_NOISE: "SNR/AuSTIN [dB]",
        SIGNAL_65_DB_SPL: "Signal 65 dB SPL",
        KIDS_SPEECH_PERCEPTION_WITH_HA: "Kids speech perception, with HA",
        KIDS_SPEECH_PERCEPTION_WITH_CI: "Kids speech perception, with CI",
        MANCHESTER_WORDS: "Manchester words [%]",
        MANCHESTER_VOWELS: "Manchester vowels [%]",
        MANCHESTER_CONSONATS: "Manchester consonats [%]",
        MANCHESTER_PHONEMES: "Manchester phonemes [%]",
        DE_VAULT_COMMON_PHRASES: "De Vault common phrases [%]",
        SPEECH_SPATIAL_QUALIATIES_WITH_HA: "Speech Spatial Qualities (SSQ), with HA",
        SPEECH_SPATIAL_QUALIATIES_WITH_CI: "Speech Spatial Qualities (SSQ), with CI",
        SPEECH_HEARING: "Speech hearing",
        SPACIAL_HEARING: "Spacial hearing",
        QUALITY_OF_HEARING: "Quality of hearing",
        OVERALL_SCORE: "Overall score",
        IT_MAIS_WITH_CI: "IT-MAIS, with CI",
        IT_MAIS_SCORE: "IT-MAIS score",
        ERROR_500_TEXT:
            'We are sorry, an error occurred. Please try again later. If the error persists, please <a href="https://www.aoqan.org/contact/" target="_blank">contact the supprt team</a>.',
        PATIENT_AGE_16_YEARS: "Patient age: 16 yrs",
        TOTAL_NUMBER_OF_PATIENTS: "Total number of patients",
        UNDER_16_YEARS: "Under 16 years",
        PREMATURITY: "Prematurity",
        INTERVENTIONS: "Interventions",
        TONSILLECTOMY: "Tonsillectomy",
        ADENOIDECTOMY: "Adenoidectomy",
        GROMMET_SURGERY: "Grommet Surgery",
        INTERVENTIONS_HINT: "* Related to the total number of cases",
        GROMMETS: "Grommets",
        PRE_OP_ASSESSMENT: "Pre-op assessment",
        HEARING_ASSESSMENT: "Hearing assessment",
        INDICATION: "Indication",
        OTITIS_MEDIA_HISTORY_ASSESSMENT: "Otitis media history assessment",
        GROMMET_SIDES: "Grommet sides",
        FIRST_GROMMET_INSERTION: "First grommet insertion",
        TYPE_OF_GROMMET: "Type of Grommet",
        WITH_ADENOIDECTOMY: "With adenoidectomy",
        ADENOIDECTOMY_DONE_BEFORE_HINT: "Has an adenoidectomy been done before?",
        ADENOIDECTOMY_DONE_THIS_TIME_HINT: "Has an adenoidectomy done this time?",
        EARDROPS: "Eardrops",
        EARDROPS_INTRA_OPERATIVELY_HINT: "Intra-operatively",
        EARDROPS_POST_SURGERY_HINT: "Prescription for use post surgery",
        POST_OP_REVIEW: "Post-op review",
        POST_OP_APPOINTMENT: "Post-op appointment",
        IN_SITE_PATENT: "Grommet in-site/patent",
        RIGHT_EAR: "RIGHT EAR",
        LEFT_EAR: "LEFT EAR",
        POST_OP_REVIEW_AFTER_GROMMET_INDICATION_HINT: "Hearing assessment after grommet indication?",
        AUDIOGRAMS: "Audiograms",
        AUDIOGRAMS_HINT: "If an audiogram has been performed pre- and post-op, has there been a 10 dB or better improvement at 1000 Hz?",
        OTORRHEA_CARD_TITLE: "Was otorrhea present and/or reported in one or both ears?",
        TELEHEALTH: "Telehealth",
        TIME_AFTER_SURGERY: "Time after surgery",
        OM_6_QUESTIONNAIRE: "OM-6 questionnaire",
        TOTAL_SCORE_OM_6: "Total score (OM-6)",
        OTITIS_MEDIA_6_OM_6: "Otitis Media-6 (OM-6)",
        ONE_MONTH_POST_OP: "1 mo post op",
        SIX_MONTHS_POST_OP: "6 mo post op",
        OM_SIX_SCORE: "OM-6 score",
        TONSILS_ADENOIDS_GROMMETS_STATISTICS: "Tonsils/Adenoids/Grommets statistics",
        TAG_EVALUATIONS: "TAG evaluations",
        TAG_EVALUATIONS_TITLE: "TAG Evaluations - AOQAN",
        IN_SITU_PATENT: "Grommet in-situ/patent",
        HOW_TO_LOAD_DATA_PLEASE_SET_YOUR: "Sie können ",
        HOW_TO_LOAD_DATA_FILTER_CRITERIA: "Filterkriterien",
        HOW_TO_LOAD_DATA_OR: "auswählen oder",
        HOW_TO_LOAD_DATA_GET_ALL_DATA: "Alle Daten anzeigen",
        RECORDS: "Einträge",
        OPEN: "Öffnen",
        OTHER: "Andere...",
        DOWNLOAD_HEADER: "Datei download",
        DOWNLOAD_DETAILS: "Ihr Download startet in wenigen Sekunden automatisch. Sollte er nicht automatisch starten, können Sie auf diesen Link klicken, um den",
        DOWNLOAD_LINK: "Download erneut manuell zu starten.",
        DOWNLOAD_NOTES: "Bitte beachten Sie, dass der Download einen Moment dauern kann, je nach Netzwerkverbindung und Browsereinstellungen. Wir danken Ihnen für Ihre Geduld. Nach dem Download können Sie diese Browser-Registerkarte schließen."
    }
};

// a function to register the plugin for Vue instances
export function LocalizerPlugin(Vue, options) {
    Vue.prototype.$i18n = options.plugin[process.env.VUE_APP_LANGUAGE];
}
